import React from 'react';
var TctWindowEventContext = React.createContext({});
export var TctWindowEventProvider = TctWindowEventContext.Provider;
export var TctWindowEventConsumer = TctWindowEventContext.Consumer;
export default TctWindowEventContext;
//# sourceMappingURL=tct-window-context.js.map